import TFLink from "../TFLink/TFLink";

interface TFButtonProps {
  title: string;
  type?: "default" | "primary" | "red";
  onClick?: () => void;
  href?: string;
  noLang?: boolean;
  className?: string;
}

const TFButton = ({
  title,
  type = "default",
  onClick,
  href,
  noLang,
  className = "",
}: TFButtonProps) => {
  const baseClasses =
    "flex-1 text-sm font-medium px-4 py-2.5 rounded-full transition-colors";

  const typeClasses = {
    primary: "bg-black/10 text-black hover:bg-black/15",
    red: "bg-red-600 text-white hover:bg-red-700",
    default:
      "border border-black/20 hover:border-black/40 hover:bg-black/5 text-black",
  };

  const classes = `${baseClasses} ${typeClasses[type]} ${className}`;

  // If href is provided, use TFLink for navigation with locale handling
  if (href) {
    return (
      <TFLink href={href} noLang={noLang} className={classes}>
        {title}
      </TFLink>
    );
  }

  // Otherwise, use button with onClick
  return (
    <button onClick={onClick} className={classes}>
      {title}
    </button>
  );
};

export default TFButton;
